<div class="modal-boton-panico">
  <div class="modal-boton-panico-info">
    <div class="info info-left">
      <div class="info-detail">
        <span>
          <sit-icon [icon]="Icon.location_w"></sit-icon>
        </span>
        <span class="long-address">
          {{properties?.address}}
        </span>
      </div>
      <div class="info-detail">
        <span>
          <mat-icon> phone</mat-icon>
        </span>
        <span class="span-text">
          {{properties?.phone}}
        </span>
      </div>
    </div>
    <div class="info info-right">
      <span>
        <mat-icon style="font-size: 50px; height: 50px; width: 50px;">devices</mat-icon>
      </span>
      <span class="span-text">
        {{properties?.deviceId}}
      </span>
    </div>
  </div>
  <div class="later-details">
    <div class="detail"  mat-raised-button #tooltip="matTooltip" matTooltip="Fecha de Registro " matTooltipPosition="above">
      <sit-icon [icon]="Icon.calendar_w" format="svg" class="icon-size-24" colorClass="icon-fill-white" />
      <span class="span-text">
       {{ properties?.registerDate | date: 'dd/MM/yyyy' }}
      </span>
    </div>
    <div class="detail" mat-raised-button #tooltip="matTooltip" matTooltip="Hora de registro" matTooltipPosition="above">
      <mat-icon>access_time</mat-icon>
      <span class="span-text">
        {{ properties?.registerDate | date: 'HH:mm:ss' }}
      </span>
    </div>
  </div>
</div>
